export default function CitationPanel({ citations }) {
  if (!citations.length) return null;

  return (
    <div className="citation-panel">
      <h4>Sources</h4>
      <ul>
        {citations.map((c, i) => (
          <li key={i}>
            📄 {c.document} → {c.section} / {c.subsection}
          </li>
        ))}
      </ul>
    </div>
  );
}
